export const APP_STORE_URL = 'https://apps.apple.com/app/id6762184199';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=se.partikampen.app';

export function DownloadTiles() {
  return (
    <div className="hero-download">
      <a
        className="download-tile"
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="/qr-appstore.svg" alt="QR-kod för App Store" />
        <span className="download-tile-label">App Store</span>
      </a>
      <a
        className="download-tile"
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="/qr-googleplay.svg" alt="QR-kod för Google Play" />
        <span className="download-tile-label">Google Play</span>
      </a>
    </div>
  );
}
